export default {"src":"/_next/static/media/left-hand.928b590e.svg","height":150,"width":259,"blurWidth":0,"blurHeight":0};